import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'investment_horizon') {
    return;
  }

  const $investmentHorizon = $('#investmentHorizon input[type=radio]', $form);

  $investmentHorizon.on('click', (inputElement) => {
    $form.submit();
  });
})
